import ModelActionsService from 'services/storageModelActions/ModelActionsService';
import { CityResponseDTO, CreateCityRequestDTO } from 'typings/dto/city';
import IRegionActionsService from './IRegionActionsService';
import { PATH_BACKEND } from 'configs/routes/pathsBackend';
import NavigateFrontendUtils from 'utils/NavigateFrontend';

export default class RegionActionsServiceImpl
  extends ModelActionsService<City, CreateCityRequestDTO, CityResponseDTO>
  implements IRegionActionsService
{
  /** @throws `BackendResponseError` */
  public getValuesFromOrderForFilter = (): Promise<void> => {
    const url = PATH_BACKEND.region.orderFilter;
    const lso = NavigateFrontendUtils.getLocationSearchObjectFromCurrentLocation();
    const active = lso.active;
    const archiveYear = lso.archiveYear;
    return this.getAllForFilter(undefined, { active, archiveYear }, url);
  };
}
